<template>
    <div class="menusView">
        <div v-if="activeIndexIF" style="display: flex; justify-content: space-between; height: 56px">
            <div class="leftView">
                <div style="position: relative">
                    <img class="ml20" :src="logo" alt="" />
                </div>
                <div class="dz-flexitem-1 dz-flex-center" style="padding-left: 40px">
                    <div>
                        <el-menu
                            :class="baseType"
                            mode="horizontal"
                            :background-color="isPuti ? '#0078ff' : '#ff6000'"
                            text-color="#fff"
                            active-text-color="#fff"
                            @select="menuSelect"
                            style="width: fit-content"
                            id="quick-tabs"
                        >
                            <el-submenu index="1">
                                <template slot="title">
                                    <img
                                        src="https://oss.fjdaze.com/yunpuhuo/teach/top-bar/cyfw.png"
                                        class="top-icon"
                                    />
                                    常用服务
                                    <span v-if="synStatus == 1" class="sync-tips">同步中</span>
                                </template>
                                <el-menu-item index="1-1">一键铺货</el-menu-item>
                                <el-menu-item index="1-2">
                                    <div class="label">
                                        全店铺货
                                        <img src="https://oss.fjdaze.com/yunpuhuo/teach/top-bar/hot.png" />
                                    </div>
                                </el-menu-item>
                                <el-menu-item index="1-3">{{ synStatus == 0 ? '同步商品' : '同步中' }}</el-menu-item>
                                <el-menu-item index="1-4">源商品同步</el-menu-item>
                            </el-submenu>
                            <el-submenu index="2">
                                <template slot="title">
                                    <img
                                        src="https://oss.fjdaze.com/yunpuhuo/teach/top-bar/phsz.png"
                                        class="top-icon"
                                    />
                                    铺货设置
                                </template>
                                <el-menu-item index="2-1">
                                    <div class="label">
                                        定时铺货<img src="https://oss.fjdaze.com/yunpuhuo/teach/top-bar/new.png" />
                                    </div>
                                </el-menu-item>
                                <el-menu-item index="2-jgsz">价格设置</el-menu-item>
                                <el-menu-item index="2-zjyf">再加运费</el-menu-item>
                                <el-menu-item index="2-ztsp">主图视频</el-menu-item>
                                <el-menu-item index="2-djyl"
                                    ><div class="label">
                                        低价引流<img src="https://oss.fjdaze.com/yunpuhuo/teach/top-bar/hot.png" /></div
                                ></el-menu-item>
                                <el-menu-item index="2-mgcbmd">敏感词白名单</el-menu-item>
                                <el-menu-item index="2-spxg">商品限购</el-menu-item>
                                <el-menu-item index="2-glbph"
                                    ><div class="label">
                                        过滤不铺货<img
                                            src="https://oss.fjdaze.com/yunpuhuo/teach/top-bar/star.png"
                                            class="star"
                                        /></div
                                ></el-menu-item>

                                <el-menu-item index="2-sxys"
                                    ><div class="label">
                                        属性预设<img src="https://oss.fjdaze.com/yunpuhuo/teach/top-bar/hot.png" /></div
                                ></el-menu-item>
                                <el-menu-item index="1-5">尺码模板</el-menu-item>
                                <el-menu-item index="1-6">图书标品</el-menu-item>
                            </el-submenu>
                            <el-submenu index="3">
                                <template slot="title"
                                    ><img
                                        src="https://oss.fjdaze.com/yunpuhuo/teach/top-bar/ddfw.png"
                                        class="top-icon"
                                    />多店服务</template
                                >
                                <el-menu-item index="3-1"
                                    ><div class="label">
                                        多店铺货<img src="https://oss.fjdaze.com/yunpuhuo/teach/top-bar/hot.png" /></div
                                ></el-menu-item>
                                <el-menu-item index="3-2">多店管理</el-menu-item>
                                <el-menu-item index="3-3">多店铺货记录</el-menu-item>
                            </el-submenu>
                            <el-submenu index="4">
                                <template slot="title"
                                    ><img
                                        src="https://oss.fjdaze.com/yunpuhuo/teach/top-bar/spyh.png"
                                        class="top-icon"
                                    />商品优化</template
                                >
                                <el-submenu index="4-1">
                                    <template slot="title"
                                        ><div class="label">
                                            批量修改<img
                                                src="https://oss.fjdaze.com/yunpuhuo/teach/top-bar/hot.png"
                                            /></div
                                    ></template>
                                    <el-menu-item index="4-1-上下架">上下架</el-menu-item>
                                    <el-menu-item index="4-1-删除">删除商品</el-menu-item>
                                    <el-menu-item index="4-1-标题">商品标题</el-menu-item>
                                    <el-menu-item index="4-1-库存">商品库存</el-menu-item>
                                    <el-menu-item index="4-1-价格SKU">商品价格</el-menu-item>
                                    <el-menu-item index="4-1-跨类目属性">跨类目属性</el-menu-item>
                                    <el-menu-item index="4-1-货号">商品货号</el-menu-item>
                                    <el-menu-item index="4-1-预售">商品预售</el-menu-item>
                                    <el-menu-item index="4-1-运费模板">运费模板</el-menu-item>
                                    <el-menu-item index="4-1-商品限购">商品限购</el-menu-item>
                                    <el-menu-item index="4-1-商品主图">商品主图</el-menu-item>
                                    <el-menu-item index="4-1-商品详情图">商品详情图</el-menu-item>
                                    <el-menu-item index="4-1-七天无理由退换货">七天无理由</el-menu-item>
                                </el-submenu>
                                <el-menu-item index="4-2">质量分检测</el-menu-item>
                                <el-menu-item index="4-3">一键白底图</el-menu-item>
                                <el-menu-item index="4-4">违禁词检测</el-menu-item>
                                <el-menu-item index="4-5">重复商品检测</el-menu-item>
                            </el-submenu>
                        </el-menu>
                    </div>
                    <div class="tools" v-if="baseType === 'PUTI'">
                        <el-popover placement="bottom" width="380" trigger="hover">
                            <div v-for="(item, index) in putiToolsData" :key="index">
                                <div class="pb10 curp">
                                    <img :src="item.img" /><span class="dz-fwb ml8">{{ item.title }}</span>
                                    <a :href="item.link" target="_blank" class="ml10">官方后台</a>
                                </div>
                                <div class="dz-flex-wrap pb25">
                                    <p
                                        v-for="val in item.children"
                                        :key="val.name"
                                        :style="{ width: item.children.length > 1 ? '33.3%' : '100%' }"
                                        class="curp fz13 dz-bar-hover"
                                    >
                                        <span class="curp" @click="getOpen(val.url)">{{ val.name }}</span>
                                    </p>
                                </div>
                            </div>
                            <div slot="reference" class="curp c-fff dz-flex-center">
                                <div :class="baseType === 'DAZE' ? 'more' : 'puti-more'">
                                    <img
                                        class="mr9"
                                        src="https://oss.fjdaze.com/oneKeyCopy1688/iconImg/tools/more-platforms.gif"
                                    />更多平台工具
                                </div>
                            </div>
                        </el-popover>
                    </div>
                </div>
            </div>
            <div style="flex: 1"></div>
            <div class="dz-flex-center user-info">
                <div class="syc-btn" @click="$bus.$emit('openSyn'), setHmt('顶部导航_点击【同步商品】')">
                    {{ synStatus === 2 ? '同步中' : '同步商品' }}
                </div>

                <notifications ref="notifications"></notifications>

                <el-popover placement="bottom" trigger="hover">
                    <div class="fz12 mb6">手机号码：170 5203 0091</div>
                    <div class="fz12 mb6">服务时间：周一到周五</div>
                    <div class="pl60 mb20 fz12">09:00 ~ 18:00</div>
                    <img :src="`${kefuImage}?t=${new Date().getTime()}`" class="w140" />

                    <div slot="reference" class="c-fff curp mr20" data-point="顶部导航_点击【联系客服】">联系客服</div>
                </el-popover>

                <div @click="shoucang" class="c-fff curp">收藏本站</div>

                <div class="dz-shop dz-flex dz-aic" :class="{ puti: isPuti }" @click="setHmt('首页_切换店铺')">
                    <div class="mr20">
                        <span class="upgrade-btn" @click="toBuy(), setHmt('顶部导航_点击【升级/续费】')"
                            >升级/续费</span
                        >
                        <div class="c-fff dz-tac fz12">还剩：{{ surplusDays }}天</div>
                    </div>

                    <div>
                        <el-popover
                            placement="bottom"
                            width="380"
                            ref="popverRef"
                            v-model="showPopover"
                            trigger="manual"
                            @hide="hidePopver"
                            @show="showPopver"
                        >
                            <router-link
                                to="/shopManagement/multiShop"
                                class="dz-show-manage dz-link pb10 blueFont border-b"
                                >多店铺管理</router-link
                            >
                            <div v-if="shopList.length" style="overflow-y: auto; max-height: 450px">
                                <div v-for="(item, index) in shopList" :key="index">
                                    <p class="pt10 dz-fwb" style="font-size: 13px; color: #999">
                                        {{ item.groupName }}>>
                                    </p>
                                    <div>
                                        <ul
                                            style="
                                                display: flex;
                                                margin-bottom: 10px;
                                                align-items: center;
                                                flex-wrap: wrap;
                                            "
                                        >
                                            <li
                                                class="mr30 curp mt20 blueFont"
                                                v-for="item in item.shopInfos"
                                                :key="item.memberId"
                                                @click="toShop(item.memberId)"
                                            >
                                                {{ item.shopName }}
                                            </li>
                                        </ul>
                                    </div>
                                </div>
                            </div>
                            <div v-else class="pt30 pb20">
                                <p disabled style="text-align: center">你还未添加其它店铺信息</p>
                            </div>
                            <span
                                slot="reference"
                                class="switch-item"
                                @click="(showPopover = !showPopover), setHmt('顶部导航_点击【切换】')"
                            >
                                切换
                                <i class="iconfont icon-qiehuan ml3" style="font-size: 14px"></i>
                            </span>
                        </el-popover>
                        <div @click="copy()" class="switch-item" style="text-decoration: underline">本店授权码</div>
                    </div>
                </div>
                <el-popover placement="bottom-end" width="600" :visible-arrow="false">
                    <div class="dz-popover">
                        <LimitTable />
                    </div>
                    <div slot="reference">
                        <div class="c-fff fz12">
                            <img
                                v-if="userInfo.versionNo && !userInfo.versionNo.includes('试用版')"
                                src="@tiktok/assets/img/vip.png"
                            />
                            {{ userInfo.versionNo }}
                        </div>
                        <div class="dz-flex-center info-pop mt4">
                            <span :title="userInfo.name"> {{ userInfo.name }} </span>
                            <i class="el-icon-arrow-down ml4"></i>
                        </div>
                    </div>
                </el-popover>
            </div>
            <synchronization
                ref="synchronization"
                @synChange="
                    (val) => {
                        $bus.$emit('getSynStatus', val);
                        synStatus = val;
                    }
                "
            />
            <LimitTable v-if="false" />
        </div>
    </div>
</template>

<script>
import dayjs from 'dayjs';
import { mapState } from 'vuex';
import synchronization from './synchronization';
import { kefuImage, baseType } from '@tiktok/config/index';
import { modules } from 'daze-cloud-components';

import Notifications from '@tiktok/components/notifications/index';

const {
    homePage: { LimitTable },
} = modules;

import optionsData from '@/plugins/options';
export default {
    components: {
        synchronization,
        Notifications,
        LimitTable,
    },
    props: {},
    data() {
        return {
            baseType,
            isPuti: baseType === 'PUTI',
            logo:
                baseType === 'PUTI'
                    ? 'http://oss.fjdaze.com/oneKeyCopy1688/common/logo/dy-puti-logo.png' // ? require(`../../assets/img/puti-logo.png`)
                    : 'http://oss.fjdaze.com/oneKeyCopy1688/common/logo/dy-logo.png',
            kefuImage,
            menuIndex: 0,
            surplusDays: 0,
            synStatus: 0,
            dialogVisible: false,
            mobilePhone: '',
            downloadUrl: '',
            activeIndexIF: true,
            isRotate: false, // 旋转图标
            userInfo: {},
            isUserRotate: false,
            showNavigation: true,
            fwRechargeCount: 0,
            timer: null,
            showPopover: false,
            toolsData: optionsData.toolsData, //更多平台工具
            putiToolsData: optionsData.putiToolsData,
            readNumUrl: `${this.$dzpublic}/fullPlatform/menageNotices/readNum`, //未读数量
        };
    },
    computed: {
        ...mapState({
            activeIndex: (state) => {
                return state.store.activeIndex;
            },
            userData: (state) => {
                return state.store.userInfo;
            },
            shopList: (state) => {
                return state.store.shopList;
            },
        }),
    },
    mounted() {
        this.$store.dispatch('setUserInfoRunAsync').then(() => {
            this.userInfo = this.$store.state.userInfo;
            if (this.userInfo.serEndTime) {
                const serEndTime = this.userInfo.serEndTime;
                if (serEndTime) {
                    const date1 = new Date(serEndTime.split(' ')[0]);
                    const date2 = new Date(dayjs().format('YYYY-MM-DD'));

                    const day = (date1 - date2) / 1000 / 60 / 60 / 24;
                    this.surplusDays = day < 0 ? 0 : day;
                } else {
                    this.surplusDays = 0;
                }
            }
        });

        this.downloadUrl = '/app/users/settings/quick_login/links/my/download';
        this.getShopInfosByMemberId();
        this.$bus.$on('moreShop', () => {
            this.showPopover = true;
        });
    },
    methods: {
        menuSelect(key) {
            if (key.indexOf('2-') !== -1) {
                this.$router.push({ path: '/copy/index' });
                switch (key) {
                    case '2-1':
                        this.$router.push({ path: '/copy/index' });
                        break;
                    default:
                        setTimeout(() => {
                            this.$bus.$emit('openConfigDialog', key.split('-')[1]);
                        }, 500);
                        break;
                }
            } else if (key.indexOf('4-1') !== -1) {
                // versionNo 试用版 标准版 高级版 豪华版
                if (this.userData.versionNo === '试用版') {
                    this.$message.warning('您目前为试用版本，暂不支持体验批量修改功能，升级续费后即可使用~');
                    return;
                }
                this.$router.push({ path: '/batchModify/modify?title=' + key.split('-')[2] });
            } else {
                switch (key) {
                    case '1-1':
                        this.$router.push({ path: '/copy/index' });
                        break;
                    case '1-2':
                        this.$router.push({ path: '/copy/index?SelectLiVlaue=replication' });
                        break;
                    case '1-3':
                        this.$refs.synchronization.handleSyn();
                        break;
                    case '1-4':
                        this.$router.push({ path: '/sourceList/commodity' });
                        break;
                    case '1-5':
                        this.$router.push({ path: '/copy/sizeTemplate' });
                        break;
                    case '1-6':
                        this.$router.push({ path: '/copy/books' });
                        break;
                    case '3-1':
                        this.$router.push({ path: '/copy/index?initDom=duodian' });
                        break;
                    case '3-2':
                        this.$router.push({ path: '/shopManagement/multiShop' });
                        break;
                    case '3-3':
                        this.$router.push({ path: '/manyCopy/manyRecord' });
                        break;
                    case '4-2':
                        this.$router.push({ path: '/qualityScore/qualityScore' });
                        break;
                    case '4-3':
                        this.$router.push({ path: '/oneWhiteImg' });
                        break;
                    case '4-4':
                        this.$router.push({ path: '/sourceList/check/checkCenter' });
                        break;
                    case '4-5':
                        this.$router.push({ path: '/commodityMGT/productDetection' });
                        break;
                    default:
                        break;
                }
            }
        },
        getPhoto() {
            this.$ajax.post('//api.fjdaze.com/kuaio/api/ForbiddenWord/PlatformMember/GetFwCount', {}).then((res) => {
                // // 剩余产品图片检测个数
                if (res.result.fwCount <= 0) {
                    this.fwRechargeCount = 0;
                } else {
                    this.fwRechargeCount = res.result.fwCount;
                }
            });
        },

        toOrder() {
            this.$router.push('/vip/order');
        },
        goRouter: function (index, path, data) {
            if (this.$route.path != path && !data.isToLink) {
                this.$router.push({ path: path });
                this.$store.commit('setActiveIndex', data.activeIndex);
            } else if (data.isToLink && data.isOpen) {
                window.open(path);
                this.activeIndexIF = false;
                setTimeout(() => {
                    this.activeIndexIF = true;
                }, 500);
            } else if (data.isToLink && !data.isOpen) {
                location.href = path;
                this.activeIndexIF = false;
                setTimeout(() => {
                    this.activeIndexIF = true;
                }, 500);
            }
        },
        handleSelect(key) {
            const that = this;
            if (key != 4 && key != 5) {
                that.$store.commit('setActiveIndex', key);
            } else {
                this.activeIndexIF = false;
                setTimeout(() => {
                    this.activeIndexIF = true;
                }, 500);
            }
        },
        toLink(i) {
            switch (i) {
                case 1:
                    window.open(
                        'https://pc.1688.com/product/detail.htm?productCode=ZekX%2FN0ZUcG0NMHd7BC2NnsW8ch%2Bj1IawQ%2FVGHZ2xZY%3D&productType=GROUP'
                    );
                    break;
                case 2:
                    window.open('https://fuwu.taobao.com/ser/detail.htm?service_code=ts-12103&code=ts-12103');
                    break;
                case 3:
                    window.open('https://fuwu.pinduoduo.com/service-market/service-detail?detailId=5752');
                    break;
                case 4:
                    window.open('https://fuwu.kwaixiaodian.com/detail?id=673760676175');
                    break;
                default:
                    break;
            }
        },
        refresh() {
            // 点击的时候为true
            this.isRotate = true;
            this.$store.dispatch('setUserInfoRunAsync');
            // 至少会转3s
            setTimeout(() => {
                this.getEnd();
            }, 2000);
        },
        handleSyn() {
            if (this.synStatus != 0) {
                return;
            }
            this.$refs.synDialog.open();
        },
        getEnd() {
            this.isRotate = false;
        },
        shoucang() {
            this.setHmt('顶部导航_点击【收藏本站】');
            this.$alert(
                `<p style="font-size:16px;color:#333;padding-bottom:5px;">收藏本站，下次可直接从浏览器访问本站</p>
                <p>请手动点击浏览器左上角的 “五角星” 添加收藏，或按快捷键【Ctrl + D】。</p>`,
                '',
                {
                    dangerouslyUseHTMLString: true,
                    confirmButtonText: '我知道了',
                }
            );
        },
        QQfun() {
            window.open('http://wpa.qq.com/msgrd?v=3&uin=568076598&site=qq&menu=yes');
        },
        /**
         * @name: renew
         * @Description: 续费
         * @param {}
         * @return:
         * @Author:
         */
        renew() {
            window.open('https://fuwu.jinritemai.com/detail?from=tab&service_id=97');
        },
        getShopInfosByMemberId() {
            this.$store.dispatch('getShopInfosByMemberId');
        },
        // 前往指定店铺
        toShop(memberId) {
            this.$ajax
                .post('/api/tiktok/User/GetMultiShopToken', {
                    multiShopUid: memberId,
                })
                .then((res) => {
                    console.log(res);
                    this.$router.push({
                        path: '/login?code=' + res.result,
                    });
                });
            this.setHmt('首页_点击切换选中店铺');
        },
        copy() {
            // 生成三位随机数
            var num = '';
            for (var i = 0; i < 3; i++) {
                num += Math.floor(Math.random() * 10);
            }
            let date = new Date().getTime() / 1000;
            let objNum = num + '-' + this.$token + '-' + date;
            let that = this;
            this.$copyText(objNum).then(
                function () {
                    that.$message.success('复制成功');
                },
                function () {
                    that.$message.warning('复制失败');
                }
            );
            localStorage.setItem('shopAuthToken', objNum);
        },
        hidePopver() {
            document.removeEventListener('click', this.closePopover);
        },
        showPopver() {
            setTimeout(() => {
                document.addEventListener('click', this.closePopover);
            }, 500);
        },
        closePopover() {
            this.showPopover = false;
        },
        getOpen(url) {
            if (url) {
                window.open(url, '_blank');
            }
        },
        //打开通知
        openNotice() {
            this.setHmt('顶部导航_点击【消息通知】');
            this.$emit('getNotice');
        },
        //关闭查询
        getClone() {
            this.$refs.bell.search();
        },

        showNotifications() {
            this.$refs.notifications.showContainer();
        },
    },
};
</script>
<style lang="scss">
.el-menu--horizontal > .el-menu--popup {
    .el-submenu__title {
        background-color: #fff !important;
        color: #000 !important;
        padding: 0 17px;
        i {
            color: #000 !important;
        }
    }
    .el-menu-item {
        background-color: #fff !important;
        color: #000 !important;
        padding: 0 17px;

        &:hover {
            color: #ff6000 !important;
        }
    }
    background-color: #fff !important;
}
</style>

<style lang="scss" scoped>
.dz-shop {
    padding-left: 24px;
    margin-left: 10px;
    margin-right: 21px;
    border-left: 1px solid #ffa26a;

    &.puti {
        border-color: #388eef;
    }

    color: #fff;
    span.el-dropdown-link {
        display: inline-block;
        height: 100%;
        height: 100%;
        color: #fff;
        font-size: 12px;
    }
    ul {
        width: 500px;
        height: 200px;
        background: red;
        display: flex;
        margin: auto;
        margin-top: 100px;
        padding: 0 10px;
        align-items: center;
        li {
            background: green;
            height: 100px;
            width: 500px;
            display: inline-block;
            margin: 2px;
            line-height: 100px;
            text-align: center;
            flex: auto;
        }
    }
    .switch-item {
        cursor: pointer;
        font-size: 12px;
    }
}

.sync-tips {
    position: relative;
    font-size: 12px;

    &::after {
        position: absolute;
        content: '...';
        width: 10px;
        overflow: hidden;
        animation: toWidth 1s infinite linear both;
    }
}

.label {
    img {
        margin-left: 3px;
        margin-top: -18px;
    }
    .star {
        margin-top: -5px;
    }
}
.top-icon {
    margin-right: 6px;
}

.menusView {
    background-color: #ff6000;
    height: 56px;

    .leftView {
        display: flex;
        align-items: center;
        .el-menu-demo {
            margin-left: 30px;
        }
    }
}

.navigation {
    .navigationUl {
        box-shadow: 0px 0px 16px 0px rgba(0, 0, 0, 0.12);
        border-radius: 4px;
        .navigationLi {
            padding: 10px 16px;
            color: #666666;
            background: #ffffff;
            text-align: center;
            cursor: pointer;
        }
        .navigationLi:hover {
            color: #fff;
            background: #388eef;
        }
    }
}
.order-btn {
    width: 80px;
    height: 32px;
    line-height: 32px;
    text-align: center;
    background: linear-gradient(90deg, #ffedc7 0%, #ffd398 100%);
    opacity: 1;
    font-size: 12px;
    font-weight: normal;
    color: #b92a0c;
    border-radius: 20px;
}

.user-info {
    padding-right: 20px;
    .info-pop {
        color: #fff;
        height: 16px;
        cursor: pointer;
        font-size: 12px;
        span {
            display: inline-block;
            max-width: 60px;
            overflow: hidden;
            text-overflow: ellipsis;
            white-space: nowrap;
            text-align: right;
        }
    }
}
.tools {
    // border-right: 1px solid #ffa26a;
    // padding: 0 14px 0 0;
    .more {
        padding: 8px 14px 8px 14px;
        display: flex;
        align-items: center;
        border-radius: 10px;
        color: #fff;
        &:hover {
            background: #f44403;
        }
    }
    .puti-more {
        padding: 8px 14px 8px 14px;
        display: flex;
        align-items: center;
        border-radius: 10px;
        color: #fff;
        margin-left: 20px;
        &:hover {
            background: #388eef;
        }
    }
}

.upgrade-btn {
    position: relative;
    display: block;
    color: #ff0b0b;
    cursor: pointer;
    line-height: 22px;
    padding: 0 8px;
    border-radius: 38px;
    background-image: linear-gradient(90deg, #ffff77, #ffde5c);
    overflow: hidden;
    margin-bottom: 2px;
    font-size: 12px;
    text-align: center;
    &::after {
        content: '';
        position: absolute;
        width: 5px;
        height: 100%;
        background: rgba(255, 255, 255, 0.4);
        transform: rotate(20deg);
        animation: leftToright 1.2s ease-in-out infinite;
    }
}

.new-vip {
    justify-content: flex-end;
    padding-right: 10px;
    font-size: 12px;
    margin-top: 2px;
    color: #fbf2db;
    img {
        margin-right: 5px;
    }
}

.syc-btn {
    border-radius: 4px;
    font-size: 12px;
    line-height: 24px;
    padding: 0 8px;
    margin-right: 20px;
    color: #fff;
    border: 1px solid #fff;
    background: #fb4b0b;
    cursor: pointer;

    &:hover {
        background: #f24303;
    }
}

.dz-popover {
    font-size: 16px;
    line-height: 1;
    color: #333;

    .logout {
        i {
            font-size: 16px;
            margin-right: 7px;
        }

        text-align: right;
        cursor: pointer;

        &:hover {
            opacity: 0.5;
        }
    }
}

@keyframes leftToright {
    0% {
        left: 0;
    }
    100% {
        left: 100%;
    }
}

/deep/ .el-menu--horizontal > .el-submenu .el-submenu__title {
    height: 40px;
    line-height: 40px;
    padding: 0;
    padding-right: 16px;
    i {
        color: #fff !important;
        vertical-align: unset;
    }
}

/deep/ .el-menu--horizontal > .el-submenu .el-submenu__title:hover {
    background: unset !important;
    color: #ffff0b !important;
}

/deep/ .el-menu.el-menu--horizontal {
    border-width: 0px;
}
</style>
